import * as React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
  IsAllowed,
  PageTitle,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { InstitutionGroup } from 'cb-model';
import { useInstitutionFilter } from '../institution/useInstitutionFilter';

export const InstitutionGroupSearch = (): React.JSX.Element => {
  const initialQueryOptions = useInstitutionFilter({
    where: {
      and: [
        { fieldId: 'institution_id', operator: 'eq', value: '', display: 'hidden' },
        { fieldId: 'title', operator: 'ct', value: '' },
      ],
    },
  });
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(InstitutionGroup, initialQueryOptions);
  const gCacheQueryItem = useCacheQuery(InstitutionGroup, queryOptions);

  return (
    <>
      <PageTitle verb="Search" entity={InstitutionGroup} subtitle="Use groups to organise your members and events" />

      <Section>
        <IsAllowed entity={InstitutionGroup} action="create">
          <Link to="/admin/institution-group/create">
            <Button size="sm" variant="primary">
              Create a new Group
            </Button>
          </Link>
          <div className="mb20px" />
        </IsAllowed>
        <PaginatorAndListSettings
          entity={InstitutionGroup}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section>
    </>
  );
};
